<template>
  <CriteriaRadioCard
    ref="menu_block"
    :chech-disabled="chechDisabled"
    class="criteria-display-condidions text-left"
    :close="close"
    :header="$t('Tenders.WhenShow')"
    :model.sync="item.isDisplayed"
    not_for_all
    :options="display_conditions"
    :submit="closeMenu">
    <template #additional="{ value }">
      <div
        v-if="value == 'ON_CONDITION' && (options_criterias.length || conditions.length)"
        :key="conditions.map(el => el.id).join(',') + conditions.length"
        class="conditions filters-menu grid"
        data-qa="conditions-list"
        dense>
        <div class="h5-headline bold mt-3 black--text">
          {{ $t('Tenders.AddingCondition') }}
        </div>
        <template
          v-for="(elem, n) in conditions">
          <FilterRowNew
            :key="n + '-' + elem.id + conditions.length"
            :elem="elem"
            :items="availableItems.concat([elem])"
            :num="n"
            :with-mode="false"
            @cancel="cancel"
            @change-type="(ev) => changeType(ev, n)">
            <template
              v-if="elem.criterionControlType == 'NONE_CRITERIA'"
              #type>
              <div class="text-left secondary__red--text">
                {{ elem.title || 'Критерій не знайдено' }}
              </div>
            </template>
            <template #contain="{ item: obj }">
              <div
                v-if="obj.criterionControlType == 'NONE_CRITERIA'"
                class="v-select__selection v-select__selection--comma h11-links">
                {{ obj.containLabel }}
              </div>
              <sSelect
                v-else
                class="filter-row__filters"
                data-qa="select-item-contain_mode"
                transparent
                :value.sync="elem.contain">
                <sOption
                  v-for="containMode in elem.contains"
                  :key="`option-${containMode.value}`"
                  class="h11-links"
                  :data-qa="`option-${containMode.value}`"
                  :label="containMode.text"
                  :value="containMode.value"/>
              </sSelect>
            </template>
            <template #activator="{ item: obj }">
              <div>
                <CriteriaActivatorNumericInput
                  v-if="obj.criterionControlType == 'NUMERIC_INPUT'"
                  :key="n + 'numeric' + obj.id"
                  :criteria="obj"
                  data-qa="numeric_input-value"
                  :value.sync="obj.search"/>
                <CriteriaActivatorDictionary
                  v-else-if="obj.criterionControlType == 'DICTIONARY'"
                  :key="n + 'select' + obj.id + conditions.length"
                  data-qa="select-dictionary-value"
                  :items="obj.values"
                  :value.sync="obj.search"/>
                <sInput
                  v-else-if="obj.criterionControlType == 'NONE_CRITERIA'"
                  class="my-auto"
                  data-qa="none-criteria-value"
                  readonly
                  :value="elem.search"/>
                <CriteriaActivatorDefault
                  v-else
                  :key="n + 'select' + obj.id + conditions.length"
                  data-qa="default_input-value"
                  :items="obj.values"
                  :value.sync="obj.search"/>
              </div>
            </template>
          </FilterRowNew>
          <div
            v-if="conditionsErrorMessages[n]"
            :key="'error-' + n"
            style="color: var(--v-secondary__red-base);font-size: 12px;">
            {{ conditionsErrorMessages[n] }}
          </div>
        </template>

        <sButton
          v-if="availableItems.length"
          class="mr-auto"
          icon="plus"
          small
          type="text"
          @click="addCondition">
          {{ $t('Tenders.AddAnotherCondition') }}
        </sButton>
      </div>
    </template>
  </CriteriaRadioCard>
</template>
<script>
import FilterRowNew from 'components/common/elements/FilterRowNew.vue'
import CriteriaRadioCard from 'components/tenders/critetia/CriteriaRadioCard.vue'
import CriteriaActivatorDefault from 'components/tenders/critetia/activators/default.vue'
import CriteriaActivatorNumericInput from 'components/tenders/critetia/activators/numericInput.vue'
import CriteriaActivatorDictionary from 'components/tenders/critetia/activators/dictionaryInput.vue'

CriteriaActivatorDictionary

import { criteriasMixin, modalMixin } from 'mixins'

export default {
  name: 'criterionDisplayCondidions',
  mixins: [criteriasMixin, modalMixin],
  data() {
    return {
      conditions: [],
    }
  },
  props: {
    item: Object,
    criteria: Array,
    close: Function,
    /**
   * збереження карти в localStorage
   */
    saveCard: {
      type: Function,
      default: () => {}
    }
  },
  mounted() {
    const allContains = Object.values(this.mixin_contains)
      .filter(value => Array.isArray(value))
      .flat()

    this.conditions = this.item.dynamicCriterions.map(el => {
      let item = this.options_criterias.find(it => it?.criteriaMark == el?.targetCriterionMark)
        || {
          contains: [],
          criterionControlType: 'NONE_CRITERIA',
          containLabel: allContains.find(i => i.value === el.comparingMode)?.text,
          title: el.title
        }
      return {
        ...item,
        search: el.value,
        contain: el.comparingMode
      }
    }).filter(el => el)
  },
  computed: {
    display_conditions() {
      let items = [
        {value: 'ALWAYS', label: this.$t('Tenders.ALWAYS') },
        {value: 'ON_CONDITION', label: this.$t('Tenders.ON_CONDITION')}
      ]

      if (!this.options_criterias.length) {
        items.pop()
      }

      if (this.item.criterionControlType == 'CALCULATED') {
        items.push({value: 'NOT_DISPLAY', label: this.$t('Tenders.NOT_DISPLAY')})
      }
      return items
    },
    options_criterias() {
      const containsByType = {
        NUMERIC_INPUT: this.getContain('NUMERIC_INPUT').map(i => ({ ...i, text: i.text.toUpperCase() })),
        DICTIONARY: this.getContain('DICTIONARY').map(i => ({ ...i, text: i.text.toUpperCase() })),
      }
      const { key, id, criterionBindingLevel, criteriaMark } = this.item
      return this.criteria.reduce((acc, el) => {
        const isList = el.criterionControlType === 'DICTIONARY' && (key ? el.key !== key : el.id !== id)
        const isNumber = el.criterionControlType === 'NUMERIC_INPUT'
        const isCompatibleKind = this.item.criterionKind === 'VARIANT' ? el.criterionKind === 'VARIANT' : el.criterionKind !== 'ANALOG'
        const isCompatibleBindingLevel = criterionBindingLevel !== 'TENDER' || el.criterionBindingLevel === 'TENDER'
        if (!((isNumber || isList) && isCompatibleKind && isCompatibleBindingLevel && el.title && el.criteriaMark !== criteriaMark)) {
          return acc
        }
        const contains = containsByType[el.criterionControlType] || containsByType.DICTIONARY
        acc.push({
          id: el.id || el.key,
          criteriaMark: el.criteriaMark,
          title: el.title,
          contains,
          criterionControlType: el.criterionControlType,
          props: el,
          contain: el.contain || contains[0].value,
          search: null,
          values: el.criterionControlType === 'NUMERIC_INPUT' ? null : el.dictionaryValues?.slice(0) || el.values?.slice(0) || [],
        })
        return acc
      }, [])
    },
    availableItems() {
      let res = this.options_criterias.filter(el => !this.conditions?.some(it => el?.id == it?.id))
      return res
    },
    conditionsErrorMessages() {
      return this.conditions.map(condition =>
        this.getErrorMessage(condition)
      )
    }
  },
  methods: {
    getErrorMessage(obj) {
      if (obj?.criterionControlType === 'DICTIONARY') {
        let values = this.$_parseListValue(obj?.search)

        const hasMatchingValue = obj.values?.some(vals => values.includes(vals.title))
        return !hasMatchingValue ? 'Значення не знайдено' : ''
      }
      return obj?.search === null ? 'Заповніть значення' : ''
    },
    getContain(fieldType) {
      if (this.mixin_contains[fieldType]) {
        return this.mixin_contains[fieldType]
      }
      return this.mixin_contains.default
    },
    chechDisabled(value) {
      //this.$_checkMenuHright(this.$refs.menu_block?.$el)

      if (!value) {
        return true
      }

      if (value === 'ON_CONDITION') {
        const conditionNotMet = this.conditions.some(el => {
          if (el?.criterionControlType === 'DICTIONARY') {
            let values = this.$_parseListValue(el?.search)

            const hasMatchingValue = el.values?.some(vals => values.includes(vals.title))
            return !hasMatchingValue
          }
          return el?.search === null
        })
        if (conditionNotMet) {
          return true
        }
      }

      return !this.display_conditions.some(el => el?.value == value)
    },
    addCondition() {
      this.$set(this.conditions, this.conditions.length, this.$_.cloneDeep(this.availableItems[0]))
      this.$emit('needResize')
    },
    changeType(item, n) {
      let elem = this.$_.cloneDeep(this.options_criterias.find(el => el.id == item.id))
      elem.search = null
      this.$set(this.conditions, n, elem)
    },
    setDynamic() {
      if (this.item.isDisplayed == 'ON_CONDITION') {
        this.$set(this.item, 'dynamicCriterions', this.conditions
          .map(el => ({
            id: 0,
            targetCriterionMark: el.criteriaMark,
            targetCriterionTitle: el.title,
            title: el.title,
            comparingMode: el.contain,
            value: el.search,
          })))
      } else {
        this.$set(this.item, 'dynamicCriterions', [])
      }
    },
    setItemBy(item, elem) {
      const contains = this.getContain(elem.criterionControlType)
        .map(i => ({ ...i, text: i.text.toUpperCase() }))
      item.id = elem.id || elem.key
      item.criteriaMark = elem.criteriaMark
      item.title = elem.title
      item.contains = contains
      item.criterionControlType = elem.criterionControlType
      item.props = elem
      item.contain = elem.contain || contains[0].value
      item.search = null
      item.values = elem.criterionControlType === 'NUMERIC_INPUT' ? null : elem.dictionaryValues?.slice(0) || elem.values?.slice(0) || []
      return item
    },
    cancel(item) {
      this.conditions = this.conditions.filter(el => el.id != item.id)
      this.$forceUpdate()
    },
    closeMenu() {
      this.setDynamic()
      this.close()
      this.saveCard()
    }
  },
  components: {
    FilterRowNew,
    CriteriaRadioCard,
    CriteriaActivatorDefault,
    CriteriaActivatorDictionary,
    CriteriaActivatorNumericInput,
  }
}
</script>
